import { IAPgetOfferings, IAPupdateOfferings } from "@/utils/iap";
import { callSlackWebhook } from "@/utils/webhooks/slack";
import { getCachedOfferingsResponse, isValidCache } from "@/utils/iap/iap-cache";
import { IAPMockedProducts } from '@/utils/iap';
import { isDev } from "@/utils/debug/is-dev";

const storeLoadedKey = "offeringsLoaded";
let iapLastRequestTimestamp = 0;

/*
// IAP betöltés
// Ha sikeres: Cache-elni + dátumot hozzá menteni

// Ha sikertelen, de cache van ÉS frissebb mint 3 nap: cachelt használata + report error + háttérben retry a lentebbiek szerint

// Ha sikertelen ÉS nincs vagy régi a cache: error felugró + report error

// IAP invalidálása, kezelni ha a háttérben hagyja futni a végtelenségig: mikor az app előtérben van ÉS a legutolsó IAP betöltés régebbi mint 1 nap -> reload, rate limit sikertelen betöltésnél a retry-ra max 5 percenként

Mindenképp kapjunk error reportot, ha:
// - Nem tudta betölteni az IAP-t (akkor is, ha cache miatt a user ezt nem veszi észre)
- Ha nem vitte végig a fizetést (nem feltétlen hiba miatt, de lássuk, akár emailt is kérhetünk ilyenkor ha nem adták meg, hogy felvegyük velük a kapcsolatot)
*/
export const validateStoreConnection = () => {
    const t = 5000;

    const timeout = setTimeout(() => {
        if (!window.IAP.status.includes(storeLoadedKey)) {
            retryStoreConnectionSilent();
            if (useCachedOfferings()) return;
            useMockedOfferings();

            //app.$bus.$emit('openAppDialog','storeErrorDialog');
            //onStoreConnectionError(false);
        } else {
            window.Tracker.logEvent({
                event_name: "connect",
                event_category: "iap",
                event_label: "loaded",
            });
        }
    }, t);
}

const onStoreConnectionError = (soft = false) => {
    const error = soft ? 'useCachedOfferings' : 'useMockedOfferings';

    console.error('IAP error - ' + error);

    window.flutterEventLog.unshift({
        eventName: error,
        data: {},
    });

    // if (isDev) return;

    const params = [
        "#bugreport",
        "IAP Error - " + error,
        true,
    ];
    // callSlackWebhook(...params);

    window.Tracker.logEvent({
        event_name: "connect",
        event_category: "iap",
        event_label: error,
    });
}

const useCachedOfferings = () => {
    try {
        const cachedData = getCachedOfferingsResponse();
        if (cachedData === null || typeof cachedData.offerings !== "object") return false;
        IAPupdateOfferings(cachedData);
        app.$bus.$emit("flutter:onOfferingsUpdated");
        onStoreConnectionError(true);
        return true;
    } catch (error) {
        window.captureException(error);
        return false;
    }
}

const useMockedOfferings = () => {
    try {
        IAPupdateOfferings(IAPMockedProducts);
        app.$bus.$emit("flutter:onOfferingsUpdated");
        onStoreConnectionError(false);
        return true;
    } catch (error) {
        window.captureException(error);
        return false;
    }
}

export const retryStoreConnectionSilent = () => {
    const maxRefreshLifetimeDays = 1;
    const maxRefreshIntervalMinutes = 5;
    try {
        if (iapLastRequestTimestamp + maxRefreshIntervalMinutes * 60 * 1000 < Date.now()) {
            IAPgetOfferings(true);
            iapLastRequestTimestamp = Date.now();
        }

        if (typeof window.retryStoreConnectionSilentInterval !== "undefined") return;

        IAPgetOfferings(true);

        window.retryStoreConnectionSilentInterval = window.setInterval(() => {
            if (isValidCache(maxRefreshLifetimeDays)) return;
            IAPgetOfferings(true);
            iapLastRequestTimestamp = Date.now();
        }, maxRefreshIntervalMinutes * 60 * 1000);
    } catch (error) {
        console.error(error);
        window.captureException(error);
    }
}

export const retryStoreConnection = () => {
    return new Promise((resolve, reject) => {
        const t = 15000;
        IAPgetOfferings(true);

        app.$bus.$emit("app.showSnackbar", {color: "blue", text: "Connecting...", timeout: t});

        const timeout = window.setTimeout(() => {
            app.$bus.$emit("app.showSnackbar", {color: "red", text: "Error connecting to the Store.", timeout: 3000});
            resolve();
        }, t + 1000);

        const interval = window.setInterval(()=>{
            if (window.IAP.status.includes(storeLoadedKey)) {
                window.clearInterval(interval);
                app.$bus.$emit("app.hideSnackbar");
                // this.close();
                window.clearTimeout(timeout);
                resolve();
            };
        }, 2000);
    });
}
